var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.itsMain)?_c('h1',[_vm._v("DeltaVoid")]):_c('h1',[_c('a',{attrs:{"href":"/"}},[_vm._v("DeltaVoid")])]),_c('div',{staticClass:"sub-title"},[_vm._v(" 3D space game about an alternative universe ")])])}
var staticRenderFns = []

export { render, staticRenderFns }